import React from 'react'
import { render, MARK_LINK, NODE_UL } from 'storyblok-rich-text-react-renderer';
import RichTextButton from '@/components/Content/RichTextButton'
import RichTextTestimonial from '@/components/Content/RichTextTestimonial'
import ContentCtaCentered from '@/components/Content/ContentCtaCentered'
import { Link } from 'gatsby'
import resolveLink from '@/utils/resolveLink'

const RichText = ({ children }) => {
    return render(children, {
        // https://github.com/claus/storyblok-rich-text-react-renderer
        markResolvers: {
            [MARK_LINK]: (children, props) => {
                const { href, target, linktype } = props;
                const isExternal = linktype !== 'story'
                if (linktype === 'email') {
                    // Email links: add `mailto:` scheme and map to <a>
                    return <a href={`mailto:${href}`}>{children}</a>;
                }
                if (isExternal || target === '_blank') {
                    // External links: Check for external link and _blank and map to <a>
                    return <a href={isExternal ? href : resolveLink(href)} target={target}>{children}</a>;
                }
                // Internal links: map to <Link>
                return <Link to={resolveLink(href)}>{children}</Link>;
            }
        },
        nodeResolvers: {
            [NODE_UL]: (children) => <ul style={{ color: '#00A895', listStyle: 'square',paddingLeft:'10px',marginLeft:'20px',marginTop:'10px' }}>{children}</ul>,
        },
        blokResolvers: {
            'button' : (props) => 
            <RichTextButton {...props}/>,
            'richtext-testimonial' : (props) => <RichTextTestimonial {...props}/>,
            'content-cta-centered': (props) => <ContentCtaCentered {...props}/>,
            'code': (props) => <div className="code" dangerouslySetInnerHTML={{__html: props.code}}></div>,
        }
    });
}

export default RichText